/**
 * 有限并发执行异步任务，单个失败不阻断其他任务。
 */
export async function runWithLimit(items, worker, limit = 4) {
  if (!items.length) return
  let nextIndex = 0
  const poolSize = Math.min(limit, items.length)
  const runners = Array.from({ length: poolSize }, async () => {
    while (nextIndex < items.length) {
      const item = items[nextIndex]
      nextIndex += 1
      try {
        await worker(item)
      } catch (e) {
        // worker 内部负责更新行状态
      }
    }
  })
  await Promise.all(runners)
}

/**
 * 任务陆续加入时用的并发闸门：runWithLimit 要求一次给齐，而文件是一个个选进来、批次是边拆边加的。
 * 返回的函数接收一个任务，排到时才执行，并发不超过 limit。
 */
export function createLimiter(limit = 4) {
  let active = 0
  const waiting = []
  const next = () => {
    if (active >= limit || !waiting.length) return
    active += 1
    const { task, resolve, reject } = waiting.shift()
    Promise.resolve()
      .then(task)
      .then(resolve, reject)
      .finally(() => {
        active -= 1
        next()
      })
  }
  return (task) =>
    new Promise((resolve, reject) => {
      waiting.push({ task, resolve, reject })
      next()
    })
}
